__turbopack_context__.v({
  "emailAlertsTextContainer": "dataroomEmailAlerts-module-scss-module__eBbqqa__emailAlertsTextContainer",
  "emailAlertsWrp": "dataroomEmailAlerts-module-scss-module__eBbqqa__emailAlertsWrp",
});
